import { useEffect } from "react";
import { Link } from "react-router-dom";
import { API_HOST } from "@/constants/developers";

const PRODUCTS = [
  { name: "Linen table lamp", price: "$86", note: "Warm light for a desk" },
  { name: "Ceramic pour-over", price: "$42", note: "Everyday coffee" },
  { name: "Wool throw", price: "$120", note: "Charcoal, washed" },
];

export default function WidgetDemo() {
  useEffect(() => {
    const selector = 'script[data-widget="wgt_shoptosa_demo"]';
    if (document.querySelector(selector)) return undefined;
    const script = document.createElement("script");
    script.src = `${API_HOST}/widget.js`;
    script.async = true;
    script.dataset.widget = "wgt_shoptosa_demo";
    document.body.appendChild(script);
    return undefined;
  }, []);

  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 pt-28 pb-32" data-testid="widget-demo">
      <div className="text-[11px] tracking-luxe uppercase text-aura-muted mb-2">Demo shop</div>
      <h1 className="font-serif text-4xl md:text-5xl tracking-tight mb-4">A shop that uses the chat.</h1>
      <p className="text-base text-aura-muted leading-relaxed max-w-2xl mb-3">
        This page is on shoptosa.com, which is registered for the demo widget. Open Shop with AI and search.
        The same snippet on a domain you have not registered does not open the chat.
      </p>
      <p className="text-sm text-aura-muted leading-relaxed max-w-2xl mb-10">
        Add your own domain under <Link to="/developers/console/keys" className="link-underline">API Keys</Link>, then paste the snippet from Chat Widgets.
        example.com also covers shop.example.com.
      </p>
      <div className="grid sm:grid-cols-3 gap-4">
        {PRODUCTS.map((item) => (
          <div key={item.name} className="border border-aura-border p-5">
            <div className="h-28 bg-aura-surface mb-4" />
            <div className="text-sm font-medium">{item.name}</div>
            <div className="text-xs text-aura-muted mt-1">{item.note}</div>
            <div className="text-sm mt-3">{item.price}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
